<template>
  <b-modal
    size="xl"
    id="modal-newCapteur"
    ref="modal-newCapteur"
    :title="capteur ? 'Modifier capteur' : 'Nouveau capteur'"
    hide-footer
  >
    <b-container>
      <b-row align-h="center" class="mt-5 mb-5">
        <b-col cols="12">
          <b-card class="">
            <!-- <h3 class="mb-4">Login</h3> -->
            <b-form @submit.prevent="onSubmit">
              <b-card-header header-bg-variant="light">
                <b-row class="">
                  <!-- <b-col>
                  <b-form-group
                    label="Type capteur*"
                    label-for="sort-by-select"
                    class="mb-0"
                  >
                    <b-form-select
                      v-model="form.typeId"
                      :options="types"
                      :select-size="types.length"
                      required
                    ></b-form-select>
                  </b-form-group>
                </b-col> -->
                  <b-col cols="6">
                    <b-form-group label="Référence*" label-for="exampleInput2">
                      <b-form-input
                        type="text"
                        v-model="form.ref"
                        @input="onRefChange"
                        required
                        placeholder="Référence"
                      >
                      </b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card-header>

              <b-row class="mt-2">
                <b-col>
                  <b-form-group label="Marque" label-for="exampleInput1">
                    <b-form-input
                      id="exampleInput1"
                      type="text"
                      v-model="form.brand"
                      @input="onBrandChange"
                      placeholder="Marque"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Nom"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="text"
                      disabled
                      v-model="form.name"
                      placeholder="Nom"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Surface d'entrée*"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.entranceSurface"
                      step="0.0000001"
                      required
                      placeholder="Surface d'entrée"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Description"
                    label-for="exampleInput2"
                  >
                    <b-form-textarea v-model="form.description" rows="2">
                    </b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Contenance(l/m²)"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.contenance"
                      step="0.0000001"
                      placeholder="contenance"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Débit minimal(l/h.m²)"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.debitMinimal"
                      step="0.0000001"
                      placeholder="debitMinimal"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Rendement optique n0"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      v-model="form.rendementOptique"
                      step="0.0000001"
                      placeholder="rendementOptique"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Coef perte par conduction(W/m².K)"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      step="0.0000001"
                      v-model="form.perteThermiqueParConduction"
                      placeholder="rendementOptique"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="exampleInputGroup2"
                    label="Coef perte par convection(W/m².K²)"
                    label-for="exampleInput2"
                  >
                    <b-form-input
                      type="number"
                      step="0.0000001"
                      v-model="form.perteThermiqueParConvection"
                      placeholder="coefPerteConvection"
                    >
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <div>
                <b-button block type="submit" variant="primary"
                  >Valider</b-button
                >&nbsp;
              </div>
              <div class="mt-5 d-flex justify-content-center" v-if="isLoading">
                <b-spinner variant="success"></b-spinner>
              </div>
              <b-alert show v-if="message" dismissible :variant="variant"
                >{{ message }}
              </b-alert>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
export default {
  name: "ModalCreateEditCapteur",
  props: {
    capteur: Object,
  },
  data() {
    return {
      form: {},
      isLoading: false,
      edit: false,
      selected: "",
      message: "",
      types: [],
      variant: "warning",
      ref: '',
      brand: ''
    };
  },
  created() {
    if (this.capteur) {
      this.form = this.capteur;
    }
    // this.getTypesCapteurs();
  },
  methods: {
    onRefChange(event) {
      this.ref = event;
      this.form.name = this.brand + " - " + this.ref;
    },
    onBrandChange(event) {
      this.brand = event;
      this.form.name = this.brand + " - " + this.ref;
    },
    async onSubmit() {
      this.isLoading = true;
      let res;
      if (this.capteur) {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/capteur/updateCapteur`,
          {
            method: "POST",
            body: JSON.stringify(this.form),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      } else {
        res = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/api/v1/capteur/saveCapteur`,
          {
            method: "POST",
            body: JSON.stringify({ capteur: this.form }),
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${this.localStorage.token}`
            },
          }
        );
      }

      const data = await res.json();
      // .then((data) => {
      console.log(data);
      this.message = data.message;
      if (data.erreur) {
        this.variant = "danger";
      }

      this.isLoading = false;
      // })
      // .catch((err) => {
      //   this.isLoading = false;
      //   console.log(err);
      // });
    },
  },
};
</script>

<style></style>
